export const css = {
    speedDialNotificationIcon: '_137nMuny',
    menuItemNotificationIcon: '_3VhYCYYf',
    notificationBackground: '_26x3sYim',
    notificationForeground: '_1yyjAMj6',
    ' _key': 'base-widgets/notification-icon'
};
export default css;
